/**
 * ブログ本文埋め込み用 お問い合わせフォーム (contact-blog-form.js)
 *
 * 設計（business-inquiry.js を踏襲）:
 *   - 送信は GAS への AJAX（POST / JSON）。ページ遷移なし・その場で完了メッセージ。
 *   - payload は action:'contact_full', source:'blog' を付与。
 *     GAS側は source==='blog' の時のみ担当者へメール送信し、履歴は既存「お問い合わせ」シートに追記。
 *   - GA4: contactページと同じ form_submit(form_name:'contact_form') + Google広告 conversion を発火。
 *     ブログ識別用に form_location:'blog' / blog_handle を付与。
 *   - form-embed.js から window.idetoxContactFormInit(scope) を呼んで初期化（1記事1個前提）。
 */
(function () {
  'use strict';

  var GAS_WEB_APP_URL = 'https://script.google.com/macros/s/AKfycbxaTJqdAtAVtKbgEJblmxJATP4gSlsV2qd9ZkdtOxAV-yvmXnU6tgMnoKTDN-tEGPEo/exec';

  // Google広告（contactページと同じ設定）
  var GOOGLE_ADS_ID = 'AW-10981582719';

  var state = {
    form: null,
    submitButton: null,
    submitLabel: '',
    status: null,
    pageLoadTime: Date.now(),
    userInteracted: false,
    submitting: false
  };

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function setField(name, value) {
    var field = qs('[name="' + name + '"]', state.form);
    if (field) field.value = value || '';
  }

  function getValue(name) {
    var field = qs('[name="' + name + '"]', state.form);
    return field ? String(field.value || '').trim() : '';
  }

  function getCheckedValue(name) {
    var field = qs('input[name="' + name + '"]:checked', state.form);
    return field ? field.value : '';
  }

  function generateInquiryId() {
    var date = new Date();
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    var token = Math.random().toString(36).slice(2, 8).toUpperCase();
    // ブログ経由は接頭辞で識別できるようにする（スプレッドシートのinquiry_id列で判別可能）
    return 'CONTACT-BLOG-' + y + m + d + '-' + token;
  }

  function getBlogHandle() {
    try {
      var m = window.location.pathname.match(/\/blogs\/[^/]+\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function getDeviceInfo() {
    var ua = navigator.userAgent || '';
    return {
      type: /iPhone|Android.*Mobile/.test(ua) ? 'mobile' : (/iPad|Android/.test(ua) ? 'tablet' : 'desktop'),
      screenWidth: window.innerWidth || document.documentElement.clientWidth || '',
      browser: /Edg\//.test(ua) ? 'Edge' : (/Chrome\//.test(ua) ? 'Chrome' : (/Safari\//.test(ua) ? 'Safari' : (/Firefox\//.test(ua) ? 'Firefox' : 'unknown'))),
      os: /Windows/.test(ua) ? 'Windows' : (/Mac OS X/.test(ua) ? 'macOS' : (/iPhone|iPad/.test(ua) ? 'iOS' : (/Android/.test(ua) ? 'Android' : 'unknown')))
    };
  }

  function fillHiddenFields() {
    setField('inquiry_id', generateInquiryId());
    setField('current_url', window.location.href);
    setField('page_title', document.title);
    setField('referrer', document.referrer || '');
  }

  // ============================================================
  // Google広告タグの読み込み（ブログページには通常未読込のため）
  // contact-old.liquid と同等。重複読み込みはガード。
  // ============================================================
  function ensureGoogleAdsTag() {
    if (window.__idetoxAdsTagLoaded) return;
    window.__idetoxAdsTagLoaded = true;
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () { window.dataLayer.push(arguments); };
    }
    var existing = document.querySelector('script[data-idetox-ads-tag]');
    if (existing) return;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + GOOGLE_ADS_ID;
    script.setAttribute('data-idetox-ads-tag', '1');
    script.onload = function () {
      window.gtag('js', new Date());
      window.gtag('config', GOOGLE_ADS_ID);
    };
    document.head.appendChild(script);
  }

  // ============================================================
  // GA4 / Google広告イベント（contactページと同一の form_name で計上）
  // ============================================================
  function sendConversionEvents(payload) {
    if (typeof window.gtag !== 'function') return;
    if (window.idetoxAdsUserData) window.idetoxAdsUserData({ email: payload.email, phone: payload.phone });
    try {
      window.gtag('event', 'form_submit', {
        transport_type: 'beacon',
        event_category: 'contact',
        event_label: 'contact_form',
        form_name: 'contact_form',
        form_id: 'ContactBlogForm',
        form_destination: window.location.href,
        form_location: 'blog',
        blog_handle: payload.blog_handle || '',
        contact_method: payload.contact_method || '',
        inquiry_id: payload.inquiry_id
      });

      window.gtag('event', 'conversion', {
        transport_type: 'beacon',
        send_to: GOOGLE_ADS_ID,
        event_category: 'contact',
        event_label: 'contact_form_submit',
        form_location: 'blog',
        inquiry_id: payload.inquiry_id,
        value: 1,
        currency: 'JPY'
      });
    } catch (e) {
      if (window.console) console.error('[contact-blog] GA4送信エラー:', e);
    }

    // Yahoo広告コンバージョン（theme.liquid で全ページ定義済み）
    try {
      if (window.idetoxTrackYahooConversion) {
        window.idetoxTrackYahooConversion({ key: 'contact-blog-' + payload.inquiry_id });
      }
    } catch (e) {}

    // OpenAI広告（ChatGPT広告）コンバージョン計測 lead_created（送信成功時のみ）
    try {
      if (window.oaiq) {
        window.oaiq('measure', 'custom', { type: 'custom' }, { custom_event_name: 'idetox_contact_lead' });
      }
    } catch (e) {}
  }

  function buildPayload() {
    var device = getDeviceInfo();
    var inquiryId = getValue('inquiry_id') || generateInquiryId();
    setField('inquiry_id', inquiryId);

    return {
      action: 'contact_full',
      source: 'blog',
      inquiry_id: inquiryId,
      timestamp: new Date().toISOString(),
      name: getValue('name'),
      email: getValue('email'),
      phone: getValue('phone'),
      contact_method: getCheckedValue('contact_method'),
      inquiry_type: '',
      message: getValue('message'),
      cta_label: getValue('cta_label'),
      current_url: getValue('current_url'),
      page_title: getValue('page_title'),
      blog_handle: getBlogHandle(),
      referrer: getValue('referrer'),
      device_type: device.type,
      screen_width: device.screenWidth,
      browser: device.browser,
      os: device.os,
      elapsed_ms: Date.now() - state.pageLoadTime
    };
  }

  function showStatus(message, ok) {
    if (!state.status) return;
    state.status.hidden = false;
    state.status.textContent = message;
    state.status.classList.toggle('cbf__status--ok', !!ok);
    state.status.classList.toggle('cbf__status--error', !ok);
  }

  function clearStatus() {
    if (!state.status) return;
    state.status.hidden = true;
    state.status.textContent = '';
  }

  function validate() {
    var errors = [];
    if (!getValue('name')) errors.push('お名前');
    var email = getValue('email');
    if (!email || email.indexOf('@') < 1) errors.push('メールアドレス');
    if (!getValue('message')) errors.push('お問い合わせ内容');
    if (getCheckedValue('contact_method') === '電話' && !getValue('phone')) errors.push('電話番号（電話希望のため）');
    var agree = qs('input[name="agree"]', state.form);
    if (agree && !agree.checked) errors.push('プライバシーポリシーへの同意');

    if (errors.length) {
      showStatus('次の項目をご確認ください：' + errors.join('、'), false);
      // 計測: どの項目で検証が止まったか（項目別離脱の把握・観測用）
      try {
        if (typeof window.gtag === 'function') {
          errors.forEach(function (fieldName) {
            window.gtag('event', 'form_validation_fail', { form_id: 'blog', field_name: fieldName, reason: 'required' });
          });
        }
      } catch (e) {}
      return false;
    }
    return true;
  }

  // 簡易ボット判定（ハニーポット＋極端に早い送信）
  function botCheckFailed() {
    if (getValue('website')) return true;
    if (!state.userInteracted) return true;
    if (Date.now() - state.pageLoadTime < 2000) return true;
    return false;
  }

  async function submitForm(event) {
    event.preventDefault();
    if (state.submitting) return;

    clearStatus();
    if (!validate()) return;

    var payload = buildPayload();

    // ボット判定時は成功表示に見せかけて終了（スパマーに情報を与えない）
    if (botCheckFailed()) {
      showStatus('送信が完了しました。内容を確認して担当者よりご連絡します。', true);
      state.form.reset();
      fillHiddenFields();
      return;
    }

    state.submitting = true;
    state.submitButton.disabled = true;
    qs('span', state.submitButton).textContent = '送信中です';

    try {
      var response = await fetch(GAS_WEB_APP_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
        redirect: 'follow'
      });
      var result = { status: 'ok' };
      try { result = await response.json(); } catch (e) {}
      if (!response.ok || result.status !== 'ok') {
        throw new Error(result.message || 'submit failed');
      }

      sendConversionEvents(payload);

      showStatus('送信が完了しました。内容を確認して担当者よりメールまたはお電話でご連絡します。', true);
      state.form.reset();
      fillHiddenFields();
    } catch (error) {
      showStatus('送信中にエラーが発生しました。お手数ですが時間をおいて再度お試しください。', false);
      if (window.console) console.error('[contact-blog] 送信エラー:', error);
    } finally {
      state.submitting = false;
      state.submitButton.disabled = false;
      qs('span', state.submitButton).textContent = state.submitLabel;
    }
  }

  function bindEvents() {
    state.form.addEventListener('input', function () { state.userInteracted = true; });
    state.form.addEventListener('change', function () { state.userInteracted = true; });
    state.form.addEventListener('submit', submitForm);
  }

  function init(scope) {
    var form = qs('[data-contact-blog-form]', scope) || qs('[data-contact-blog-form]');
    if (!form) return;
    if (form.getAttribute('data-idetox-bound') === '1') return; // 二重初期化ガード
    form.setAttribute('data-idetox-bound', '1');

    state.form = form;
    state.submitButton = qs('[data-cbf-submit]', form);
    state.status = qs('[data-cbf-status]', form);
    state.submitLabel = qs('span', state.submitButton).textContent;

    fillHiddenFields();
    bindEvents();
    ensureGoogleAdsTag(); // 送信前にAdsタグを読み込んでおく（conversion計測のため）
  }

  // form-embed.js から呼べるよう公開
  window.idetoxContactFormInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
